import { ReactorParams } from "../class/element/ship/reactor"

export const basicJetReactor = {
  width: 2,
  timeBetweenShots: 20,
  range: 5,
  particleParams: {
    moveSpeed: 30,
  }
} as Partial<ReactorParams>;